import { render, staticRenderFns } from "./CarouselSelectModal.vue?vue&type=template&id=96e4c358&"
import script from "./CarouselSelectModal.vue?vue&type=script&lang=js&"
export * from "./CarouselSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports